export const names = {
  hubs: {
    shortSingle: "Partnership",
    shortPlural: "Partnerships",
    longSingle: "Community Partnership",
    longPlural: "Community Partnerships",
    slug: "partnerships",
  },
};
